import React, { useEffect, useRef, useState } from "react";
import Joinus from "../../common/Joinus";
import { WhatsAppChatbotFAQ, initialStates, servicescontent, whatsappServiceDetails } from "../home/Constant";
import ServiceMetaAni from "./ServiceMetaAni";
import Benefits from "../../common/Benefits";
import { whatsappChatbotsAdds } from "../../common/data";
import ChatbotsBenifits from "./ChatbotsBenifits";
import WhatWeDo from "./WhatWeDo";
import { Helmet } from "react-helmet";


const WhatsappChatbots = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const itemsToShow = showAll ? WhatsAppChatbotFAQ : WhatsAppChatbotFAQ.slice(0, 10);

  return (
    <>           <Helmet>
      <meta name="keywords" content="whatsapp marketing,bulk whatsapp message,whatsapp chatbots,bulk WhatsApp,whatsapp business marketing,whatsapp button,whatsapp chat button" />
    </Helmet>
      <div className="margin-topall">
        <section className="py-5 service-position servicepadding">
          <div className="container">
            <div className="meta-bg-round">
              {colors.map((color, i) => (
                <div
                  key={i}
                  id={`dot_00${i}`}
                  style={{
                    position: "absolute",
                    border: `${i == 0 ? "9px solid white" : "none"}`,
                    top: `${initialStates[i].top}px`,
                    left: `${initialStates[i].left}px`,
                    width: `${initialStates[i].width}px`,
                    height: `${initialStates[i].height}px`,
                    marginLeft: `${initialStates[i].marginLeft}px`,
                    opacity: initialStates[i].opacity,
                    backgroundColor: color,
                    borderRadius: "50%",
                    zIndex: 1000,
                    pointerEvents: "none",
                    willChange: "top, left, width, height, opacity, margin-left",
                  }}
                />
              ))}
            </div>
            <div className="pos-z-index ">
              <div className="row justify-content-center">
                <div className="col-lg-6"
                  data-aos="fade-up" data-aos-delay="300"
                >
                  <div className="">
                    <h5 className="yellowclick-sub-heading text-center py-2">
                      WhatsApp Chatbot Service
                    </h5>
                    {/* <h4 className="black-service-heading text-center font-align mt-3">
                    Unlock 5x Revenue Growth
                  </h4> */}
                    <div className="smschat-sub-heading">
                      A WhatsApp chatbot is an intelligent automation tool that interacts with users on WhatsApp without requiring live human support. Our WhatsApp chatbot service uses rule-based logic, AI, and natural language processing (NLP) to respond instantly, answer FAQs, collect customer data, book appointments, send reminders, and even drive sales - 24/7.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <WhatWeDo data={whatsappServiceDetails} />
        <ChatbotsBenifits />
        <Benefits data={whatsappChatbotsAdds} />
        <section className="py-5">
          <div className="container">
            <div>
              <h1 className="py-2 faqfont mb-5">FAQs - (WhatsApp Chatbots)</h1>
            </div>
            <div className="accordion" id="accordionExample">
              {itemsToShow.map((item, index) => (
                <div className="accordion-item border-top" key={index}
                  data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300"
                >
                  <h2 className="accordion-header" id={`heading${item.id}`}>
                    <button
                      className={`accordion-button d-flex align-items-center ${index !== 0 ? 'collapsed' : ''
                        }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${item.id}`}
                      aria-expanded={index === 0 ? 'true' : 'false'}
                      aria-controls={`collapse${item.id}`}
                    >
                      <span className="me-3 toggle-icon"></span>
                      {item.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse${item.id}`}
                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                    aria-labelledby={`heading${item.id}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body wrapfaq">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
            {WhatsAppChatbotFAQ.length > 10 && (
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            )}
          </div>
        </section>
        <Joinus />
      </div></>

  );
};

export default WhatsappChatbots;
